export default "__VITE_ASSET__Dyk5aM69__"